import { MainCollectionsDoctors } from '@/features/main/main-collections/main-collections-doctors/main-collections-doctors';
import { MainCollectionsCollection } from '@/features/main/main-collections/main-collections-collection/main-collections-collection';

export class MainCollectionsContent {
	private readonly element: HTMLElement;
	private navigation: HTMLElement;
	private doctorsElement: HTMLElement;
	private collectionElement: HTMLElement;
	private collection: MainCollectionsCollection;
	public doctors: MainCollectionsDoctors;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	public init = (): void => {
		this.navigation = this.element.querySelector('.main-collections__navigation');
		this.doctorsElement = this.element.querySelector('.main-collections__doctors');
		this.collectionElement = this.element.querySelector('.main-collections__collection');
		this.collection = new MainCollectionsCollection(this.collectionElement);
		this.doctors = new MainCollectionsDoctors({
			element: this.doctorsElement,
			navigation: this.navigation,
			collection: this.collection.slider,
		});
		this.collection.setDoctors(this.doctors.slider);
	};
}
